/**
 * User-facing error messages for the AI Wedding Planner chat.
 * Technical details are logged to the console, never shown in the UI.
 */

type Lang = "pl" | "en" | "de";

const RATE_LIMIT: Record<Lang, string> = {
  pl: "Limit zapytań AI został chwilowo wyczerpany. Spróbuj za kilka minut.",
  en: "The AI request limit has been temporarily reached. Please try again in a few minutes.",
  de: "Das KI-Anfragelimit ist vorübergehend erreicht. Bitte versucht es in einigen Minuten erneut.",
};

const FETCH_ERROR: Record<Lang, string> = {
  pl: "Nie udało się połączyć z asystentem AI. Spróbuj za chwilę.",
  en: "Could not connect to the AI assistant. Please try again in a moment.",
  de: "Verbindung zum KI-Assistenten fehlgeschlagen. Bitte versucht es gleich erneut.",
};

const GENERIC: Record<Lang, string> = {
  pl: "Przepraszam — coś poszło nie tak. Spróbuj ponownie.",
  en: "Sorry — something went wrong. Please try again.",
  de: "Entschuldigung — etwas ist schiefgelaufen. Bitte versucht es erneut.",
};

export function formatPlannerError(err: unknown, language: Lang = "pl"): string {
  console.error("[ai-planner]", err);

  const message = err instanceof Error ? err.message : String(err);
  const code =
    err && typeof err === "object" && typeof (err as Record<string, unknown>)["code"] === "string"
      ? ((err as Record<string, unknown>)["code"] as string)
      : "";

  const isFetchError = code.includes("fetch-error") || message.includes("Error fetching");
  const is429 =
    message.includes("429") ||
    message.toLowerCase().includes("quota") ||
    message.toLowerCase().includes("rate limit");

  if (is429) return RATE_LIMIT[language];
  if (isFetchError) return FETCH_ERROR[language];
  return GENERIC[language];
}
